const SpriteButton = (scene, options) => {
  let upIndex = 0;
  let overIndex = 1;
  let downIndex = 2;
  let disabledIndex = 3;
  const {
    sprite,
    action,
    x,
    y,
    up,
    over,
    down,
    calcX,
    calcY,
    dontScale,
    disabled
  } = options;

  // let disabled = disabledInput || false;

  if (up) {
    upIndex = up;
  }
  if (over) {
    overIndex = over;
  }
  if (down) {
    downIndex = down;
  }
  const scale = scene.game.defaultZoom;

  const onPointerDown = () => {
    if (!disabled) {
      button.setFrame(downIndex);
      scene.game.sfx.click.play();
    }
  };

  const onPointerUp = () => {
    if (!disabled) {
      button.setFrame(overIndex);
      if (action) {
        action();
      }
    }
  };

  const button = scene.add
    .sprite(
      x || calcX(scene),
      y || calcY(scene),
      sprite,
      disabled ? disabledIndex : upIndex
    )
    .setScale(!dontScale ? scale : 1)
    .setOrigin(0.5)
    .setInteractive()
    .on('pointerover', () => {
      if (!disabled) {
        scene.game.sfx.pointerover.play();
        button.setFrame(overIndex);
      }
    })
    .on('pointermove', () => {
      if (!disabled) {
        if (button.frame.name !== downIndex) {
          button.setFrame(overIndex);
        }
      }
    })
    .on('pointerout', () => {
      if (!disabled) {
        button.setFrame(upIndex);
      }
    })
    .on('pointerdown', onPointerDown)
    .on('pointerup', onPointerUp);

  const resizeButton = () => {
    button.setPosition(x || calcX(scene), y || calcY(scene));
    if (!dontScale) {
      button.setScale(scene.game.defaultZoom);
    }
  };

  const removeResizeListener = () => {
    scene.scale.off('resize', resizeButton);
  };

  if (calcX && calcY) {
    scene.scale.on('resize', resizeButton);
    scene.events.on('shutdown', removeResizeListener);
    button.on('destroy', removeResizeListener);
    button.resize = scene => {
      button
        .setPosition(x || calcX(scene), y || calcY(scene))
        .setScale(dontScale ? 1 : scene.game.defaultZoom);
    };
  }

  button.action = () => {
    onPointerDown();
    setTimeout(onPointerUp, 150);
  };

  button.setDisabled = value => {
    // disabled = value;
  };

  return button;
};

export default SpriteButton;
